import nonstandard_urls from "./config/nonstandard-urls";
import errorDefinition from "./config/error-definition";
// import pop from "@/utils/pop/pop";

import {Message} from 'element-ui';
import {Notification} from 'element-ui'


// import {
//   Toast
// } from 'cube-ui'

/**
 * 封装辅助函数给到http-client.js
 * 让http-client专注逻辑串联，减少代码量
 */
export default {

  getDefaultRequestConfig() {
    return {
      loading: {
        auto: true,
        time: 0,
        txt: '加载中...'
      },
      error: {
        auto: true
      }
    }
  },
  /**
   * 检查是否非标准URL（接口数据返回没按照标准）
   * @param url
   * @returns {boolean}
   */
  isNonstandardUrl: (url) => {
    url = '!' + url.split('!')[1];
    return nonstandard_urls.indexOf(url) != -1;
  },

  /**
   * 显示加载层
   * @param loading
   * loading.use: 是否需要打开加载层（默认打开）
   * loading.txt: 加载层显示文字
   * loading.time: 加载层停留时间
   */
  showLoading(loading) {
    if (loading.auto) {
      loading = Toast.$create({
        time: loading.time,
        txt: loading.txt.toString()
      }, true)
      loading.show()
    }
    return loading
  },

  /**
   * 隐藏加载层
   * @param loading
   */
  hideLoading: (loading) => {
    loading && loading.hide && loading.hide()
  },

  /**
   * 处理系统级错误
   * @param error
   */
  handleSystemError(error) {
    let errorMsg;
    const response = error.response
    if (response) {
      const status = response.status
      const msg = response.data.msg
      errorMsg = errorDefinition[status] || msg;
    } else {
      if (error.message.includes('timeout')) {
        errorMsg = errorDefinition['timeout']
      } else if (error.message.includes('Network Error')) {
        errorMsg = errorDefinition['Network Error']
      }
    }
    console.log('show.......')
    Message({
      message: errorMsg,
      type: 'error'
    })
  },

  /**
   * 处理错误
   * @param resp
   */
  handleBusiError(resp) {
    let title = '操作失败'
    let msg = ''
    switch (resp.code) {
      case 40001:
        msg = resp.data.defaultMsg
        break;
      default:
        msg = resp.msg || resp.header.message
        break;
    }
    Notification({
      title: '',
      message: msg,
      type: 'error',
      duration: 2000
    });
  }
}